import { EventEmitter } from "events";
import { inherits } from "util";
import queryParams from "./query.params";

const APP_PROTOCOL_VERSION = "1.0.0";

// app to player
const APP_EVENT_INIT = "init";
const APP_EVENT_PRELOADED = "preloaded";
const APP_EVENT_STARTED = "started";
const APP_EVENT_FINISHED = "finished";

const APP_ERROR_LEVEL_WARN = "warn"; // used for errors which are warnings
const APP_ERROR_LEVEL_FATAL = "fatal"; // used for any error which is so bad it means the app cant continue

const APP_ERROR_ACCESS_DENIED = "access_denied";
const APP_ERROR_MEDIA_ERROR = "media_error";
const APP_ERROR_NETWORK_ERROR = "network_error";
const APP_ERROR_UNKNOWN_ERROR = "unknown_error";
const APP_ERROR_RENDER_ERROR = "render_error";

const APP_INCOMING_COMMAND_START = "start";
const APP_INCOMING_COMMAND_FINISH = "finish";
const APP_INCOMING_COMMAND_USERDATA = "user_data"; // to be removed

const PARENT = window.parent;

function TriggerEvents() {
  if (!(this instanceof TriggerEvents)) return new TriggerEvents();
  this._started = false;
  EventEmitter.call(this);
  this.initIncommingMessageWatcher();
}

inherits(TriggerEvents, EventEmitter);

TriggerEvents.prototype.initIncommingMessageWatcher = function() {
  const self = this;

  if (self._started) return;
  self._started = true;

  window.addEventListener("message", function(event) {
    try {
      const msgJSON = JSON.parse(event.data);
      if (
        msgJSON.type &&
        msgJSON.type === "command" &&
        msgJSON.command &&
        msgJSON.command.name
      ) {
        switch (msgJSON.command.name) {
          case APP_INCOMING_COMMAND_USERDATA:
            self.emit("user_data", event.data);
            break;

          case APP_INCOMING_COMMAND_START:
            self.emit("start");
            break;

          case APP_INCOMING_COMMAND_FINISH:
            self.emit("finish");
            break;

          default:
            break;
        }
      }
    } catch (e) {
      // console.warn('can not parse JSON Message', e)
    }
  });
};

TriggerEvents.prototype.sendAppStatusPreloaded = function(data) {
  _sendEventWithData(APP_EVENT_PRELOADED, data);
};

TriggerEvents.prototype.sendAppStatusStarted = function(data) {
  _sendEventWithData(APP_EVENT_STARTED, data);
};

TriggerEvents.prototype.sendFinishedEvent = function(data) {
  _sendEventWithData(APP_EVENT_FINISHED, data);
};

TriggerEvents.prototype.sendErrorEvent = function() {
  // _sendEvent(APP_EVENT_ERRORED)
  // to be remove
  // silent error during implement new Protocol
  this.sendUnknownErrorEvent({});
};

TriggerEvents.prototype.sendAccessDeniedErrorEvent = function(data) {
  data = data || {};
  data.user_action_required = true;
  _sendErrorEventWithData(APP_ERROR_ACCESS_DENIED, APP_ERROR_LEVEL_FATAL, data);
};

TriggerEvents.prototype.sendMediaErrorEvent = function(data) {
  _sendErrorEventWithData(APP_ERROR_MEDIA_ERROR, APP_ERROR_LEVEL_FATAL, data);
};

TriggerEvents.prototype.sendNetworkErrorEvent = function(data) {
  _sendErrorEventWithData(APP_ERROR_NETWORK_ERROR, APP_ERROR_LEVEL_FATAL, data);
};

TriggerEvents.prototype.sendUnknownErrorEvent = function(data) {
  _sendErrorEventWithData(APP_ERROR_UNKNOWN_ERROR, APP_ERROR_LEVEL_FATAL, data);
};

TriggerEvents.prototype.sendRenderErrorEvent = function(data) {
  _sendErrorEventWithData(APP_ERROR_RENDER_ERROR, APP_ERROR_LEVEL_WARN, data);
};

TriggerEvents.prototype.sendStateEvent = function(state, info) {
  // to be remove
  // leave for silent errur during migrate to new Protocol
  _sendStateEvent(state, info);
};

function _sendAppInit() {
  const initData = { protocol: "app", version: APP_PROTOCOL_VERSION };
  _sendEventWithTypeAndData(APP_EVENT_INIT, initData);
}

function _sendStateEvent(state, info) {
  // to be remove
  // leave for silent errur during migrate to new Protocol
  if (console.debug === true) {
    if (!info) info = {};
    info.dumpLogs = console.logArray();
  }

  const infoJSON = {
    type: state,
    frameId: queryParams.frame_id || "",
    payload: info || ""
  };
  PARENT.postMessage(JSON.stringify(infoJSON), "*");
}

function _sendEventWithData(eventName, data) {
  if (!data || data === "") data = {};

  if (console.debug === true) {
    data.dumpLogs = console.logArray();
  }

  data.name = eventName;

  const infoJSON = {
    session: queryParams.frame_id || "",
    type: "event",
    event: data
  };
  console.log("_sendEventWithData [" + eventName + "] : ", infoJSON);
  PARENT.postMessage(JSON.stringify(infoJSON), "*");
}

function _sendEventWithTypeAndData(eventType, data) {
  if (console.debug === true) {
    if (!data) data = {};
    data.dumpLogs = console.logArray();
  }

  data.name = eventType;
  if (!eventType || eventType === "") {
    eventType = "data";
  }
  const infoJSON = {
    session: queryParams.frame_id || "",
    type: eventType
  };
  infoJSON[eventType] = data || "";

  console.log("_sendEventWithTypeAndData [" + eventType + "] : ", infoJSON);
  PARENT.postMessage(JSON.stringify(infoJSON), "*");
}

function _sendErrorEventWithData(code, level, data) {
  if (console.debug === true) {
    if (!data) data = {};
    data.dumpLogs = console.logArray();
  }

  if (data.error && data.error.message) {
    data.error = data.error.message;
  } else {
    data.error = "";
  }

  const infoJSON = {
    session: queryParams.frame_id || "",
    type: "error",
    error: {
      code: code,
      level: level,
      data: data || ""
    }
  };
  console.log("_sendErrorEventWithData [" + code + "] : ", infoJSON);
  PARENT.postMessage(JSON.stringify(infoJSON), "*");
}

_sendAppInit();

export default TriggerEvents;
